module.exports = __webpack_public_path__ + "static/img/SAM-ALLEN.b4c8ecb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-ALLEN.jpg
// module id = CCds
// module chunks = 0